import { useState } from "react";

import CommitMessageDialog from "./ui/CommitMessageDialog";
import { Button } from "./ui/button";

const SUCCESS_TRANSITION_DELAY_MS = 900;

interface SaveWithCommitButtonProps {
  onSave?: (commitMessage: string) => Promise<(() => void) | void> | (() => void) | void;
  onCancel?: () => void;
  name?: string;
  Extra?: React.ReactNode;
  disabled?: boolean;
}

const SaveWithCommitButton = ({
  onSave,

  name,
  disabled,
}: SaveWithCommitButtonProps) => {
  const [showCommitMessage, setShowCommitMessage] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleClose = () => {
    setShowCommitMessage(false);
    setIsSaving(false);
    setIsSuccess(false);
  };

  const handleSubmit = async (commitMessage?: string) => {
    if (!onSave) {
      return;
    }

    setIsSaving(true);

    try {
      const nextSuccessAction = await onSave(commitMessage || "");
      setIsSaving(false);
      setIsSuccess(true);

      await new Promise(resolve => {
        setTimeout(resolve, SUCCESS_TRANSITION_DELAY_MS);
      });

      nextSuccessAction?.();
      handleClose();
    } catch {
      setIsSaving(false);
    }
  };

  return (
    <>
      <Button
        size="sm"
        onClick={() => setShowCommitMessage(true)}
        className="flex items-center gap-2"
        disabled={disabled}
      >
        {name || "Save With Commit Message"}
      </Button>
      <CommitMessageDialog
        commitLabel="Workflow version change message (Optional)"
        title="Save New Workflow Version"
        saveTitle="Workflow Saved"
        onConfirm={handleSubmit}
        isLoading={isSaving}
        isSuccess={isSuccess}
        isOpen={showCommitMessage}
        onClose={handleClose}
      />
    </>
  );
};

export default SaveWithCommitButton;
